import { createSlice } from "@reduxjs/toolkit";
import { ISpecificationListState } from "../types/specification-list";
import { getSpecificationListThunk } from "../thunks/specificationListThunk";
import { ISpecificationListItemResponse } from "@/shared/services/interface/responses/ISpecificationResponse";

const initialState: ISpecificationListState = {
  specificationList: [],
  totalCount: 0,
  page: 0,
  currentPage: 0,
  limit: 0,
  nextOffset: 0,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false,
  loading: true,
  error: null,
  activeTab: "listtable",
  sort: {
    column: "createdAt",
    direction: "DESC",
    clickCount: 1,
  },
  sidebarWidth: 270,
  selectedSpecificationIds: [],
};

export const specificationListSlice = createSlice({
  name: "specificationList",
  initialState,
  reducers: {
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setSidebarWidth: (state, action) => {
      state.sidebarWidth = action.payload;
    },
    setSelectedSpecificationIds: (state, action) => {
      state.selectedSpecificationIds = action.payload;
    },
    toggleSpecificationSelection: (state, action) => {
      const specificationId = action.payload;
      const isSelected =
        state.selectedSpecificationIds.includes(specificationId);

      if (isSelected) {
        state.selectedSpecificationIds = state.selectedSpecificationIds.filter(
          (id) => id !== specificationId
        );
      } else {
        state.selectedSpecificationIds.push(specificationId);
      }
    },
    selectAllSpecifications: (state) => {
      state.selectedSpecificationIds = state.specificationList.map(
        (item) => item.id
      );
    },
    clearSelectedSpecifications: (state) => {
      state.selectedSpecificationIds = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSpecificationListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecificationListThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload) return;
        state.specificationList = action.payload
          .data as ISpecificationListItemResponse[];
        state.totalCount = action.payload.totalCount;
        state.page = action.payload.page;
        state.currentPage = action.payload.currentPage;
        state.limit = action.payload.limit;
        state.nextOffset = action.payload.nextOffset;
        state.totalPages = action.payload.totalPages;
        state.hasNext = action.payload.hasNext;
        state.hasPrevious = action.payload.hasPrevious;
      })
      .addCase(getSpecificationListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  setSort,
  setLoading,
  setActiveTab,
  setSidebarWidth,
  setSelectedSpecificationIds,
  toggleSpecificationSelection,
  selectAllSpecifications,
  clearSelectedSpecifications,
} = specificationListSlice.actions;

export default specificationListSlice.reducer;
